import { action } from 'satcheljs';

/**
 * Action to add shared folder user email
 */
export const addSharedFolderUserEmail = action(
    'ADD_SHARED_FOLDER_USER_EMAIL',
    (principalSMTPAddress: string) => ({ principalSMTPAddress })
);
